import React, { useState, useRef } from "react";
import { Button } from "react-bootstrap";

function LiveClassRecorder() {
  const [recording, setRecording] = useState(false);
  const [videoURL, setVideoURL] = useState(null);
  const mediaRecorderRef = useRef(null);
  const recordedChunksRef = useRef([]);

  const startRecording = async () => {
    try {
      // 1. Get screen stream (video + optional system audio)
      const screenStream = await navigator.mediaDevices.getDisplayMedia({
        video: true,
        audio: true, // Only works for tab system audio in Chrome
      });

      // 2. Get mic stream
      const micStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
      });

      // 3. Combine both streams
      const combinedStream = new MediaStream([
        ...screenStream.getVideoTracks(),
        ...screenStream.getAudioTracks(),
        ...micStream.getAudioTracks(),
      ]);

      recordedChunksRef.current = [];

      // 4. Create MediaRecorder
      const mediaRecorder = new MediaRecorder(combinedStream, {
        mimeType: "video/webm; codecs=vp9",
      });

      // 5. Collect chunks
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          recordedChunksRef.current.push(event.data);
        }
      };

      // 6. On stop: save and download
      mediaRecorder.onstop = () => {
        screenStream.getTracks().forEach((track) => track.stop());
        micStream.getTracks().forEach((track) => track.stop());

        const blob = new Blob(recordedChunksRef.current, {
          type: "video/webm",
        });
        const url = URL.createObjectURL(blob);
        setVideoURL(url);
        setRecording(false);

        // Auto-download the recording
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = "LiveClassRecorder.webm";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // Revoke URL after 10s
        setTimeout(() => URL.revokeObjectURL(url), 10000);
      };

      // 7. Start recording
      mediaRecorder.start();
      mediaRecorderRef.current = mediaRecorder;
      setRecording(true);
    } catch (err) {
      console.error("Error starting recording:", err);
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
  };

  return (
    <div>
      {!recording ? (
        <Button onClick={startRecording}>Start Recording</Button>
      ) : (
        <Button onClick={stopRecording}>Stop Recording</Button>
      )}
    </div>
  );
}

export default LiveClassRecorder;
